import axios from 'axios';
import { environment } from './environment';

export const axiosInstance = (token, id) => axios.create({
    baseURL: environment.baseURL,
    headers:{
        "university": id,
        "Authorization": token
    },
    timeout: environment.timeout
})
